import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import quotes from '../../config/quotes.json';

const getRandQuote = () => {
    const randIndex = Math.floor(Math.random() * quotes.length);
    return quotes[randIndex];
}

interface QuoteState {
    selectedQuote: string;
    setRandomQuote: () => void;
}

// Define the store with persist middleware
export const useQuoteStore = create<QuoteState>() (
    persist(
        (set) => ({
            selectedQuote: getRandQuote(), 
            setRandomQuote: () => set({ selectedQuote: getRandQuote() }),
        }),
        { name: 'selectedQuote' } 
    )
);